module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "ORIM-Chapter-Title-Page-Break--Body-",
    attrs: {
      "id": "_idParaDest-3",
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor002"
    }
  }), _vm._v("CHAPTER II.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Subtitle--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("the breaking of the cup")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("We walked down a broad street bordered by trees, beyond which were lime-washed, flat-roofed houses built of sun-dried brick, standing, each of them, in its own garden, till at length we came to the great market-place just as the full moon rose above the palm-trees, making the world almost as light as day. Tanis, or Rameses as it is also called, was a very fine city then, if only half the size of Memphis, though now that the court has left it I hear it is much deserted. About this market-place stood great temples of the gods, with pylons and avenues of sphinxes, also that wonder of the world, the colossal statue of the second Rameses, while to the north upon a mound was the glorious palace of Pharaoh. Other palaces there were also, inhabited by the nobles and officers of the Court, and between them ran long streets where dwelt the citizens, ending, some of them, on that branch of the Nile by which the ancient city stood.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Seti halted to gaze at these wondrous buildings.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“They are very old,” he said, “but most of them, like the walls and those temples of Amon and Ptah, have been rebuilt in the time of my grandfather or since his day by the labour of Israelitish slaves who dwell yonder in the rich land of Goshen.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“They must have cost much gold,” I answered.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“The Kings of Egypt do not pay their slaves,” remarked the Prince shortly.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Then we went on and mingled with the thousands of the people who were wandering to and fro seeking rest after the business of the day. Here on the frontier of Egypt were gathered folk of every race; Bedouins from the desert, Syrians from beyond the Red Sea, merchants from the rich Isle of Chittim, travellers from the coast, and traders from the land of Punt and from the unknown countries of the north. All were talking, laughing and making merry, save some who gathered in circles to listen to a teller of tales or wandering musicians, or to watch women who danced half naked for gifts.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Now and again the crowd would part to let pass the chariot of some noble or lady before which went running footmen who shouted, “Make way, Make way!” and laid about them with their long wands. Then came a procession of white-robed priests of Isis travelling by moonlight as was fitting for the servants of the Lady of the Moon, and bearing aloft the holy image of the goddess before which all men bowed and for a little while were silent. After this followed the corpse of some great one newly dead, preceded by a troop of hired mourners who rent the air with their lamentations as they conducted it to the quarter of the embalmers. Lastly, from out of one of the side streets emerged a gang of several hundred hook-nosed and bearded men, among whom were a few women, loosely roped together and escorted by a company of armed guards.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Who are these?” I asked, for I had never seen their like.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Slaves of the people of Israel who return from their labour at the digging of the new canal which is to run to the Red Sea,” answered the Prince.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("We stood still to watch them go by, and I noted how proudly their eyes flashed and how fierce was their bearing although they were but men in bonds, very weary too and stained by toil in mud and water. Presently this happened. A white-bearded man lagged behind, dragging on the line and checking the march. Thereupon an overseer ran up and flogged him with a cruel whip cut from the hide of the sea-horse. The man turned and, lifting a wooden spade that he carried, struck the overseer such a blow that he cracked his skull so that he fell down dead. Other overseers rushed at the Hebrew, as these Israelites were called, and beat him till he also fell. Then a soldier appeared and, seeing what had happened, drew his bronze sword. From among the throng sprang out a girl, young and very lovely although she was but roughly clad.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Since then I have seen Merapi, Moon of Israel, as she was called, clad in the proud raiment of a queen, and once even of a goddess, but never, I think, did she look more beauteous than in this hour of her slavery. Her large eyes, neither blue nor black, caught the light of the moon and were aswim with tears. Her plenteous bronze-hued hair flowed in great curls over the snow-white bosom that her rough robe revealed. Her delicate hands were lifted as though to ward off the blows which fell upon him whom she sought to protect. Her tall and slender shape stood out against a flare of light which burned upon some market stall. She was beauteous exceedingly, so beauteous that my heart stood still at the sight of her, yes, mine that for some years had held no thought of woman save such as were black and evil.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("She cried aloud. Standing over the fallen man she appealed to the soldier for mercy. Then, seeing that there was none to hope for from him, she cast her great eyes around until they fell upon the Prince Seti.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Oh! Sir,” she wailed, “you have a noble air. Will you stand by and see my father murdered for no fault?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Drag her off, or I smite through her,” shouted the captain, for now she had thrown herself down upon the fallen Israelite. The overseers obeyed, tearing her away.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Hold, butcher!” cried the Prince.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Who are you, dog, that dare to teach Pharaoh’s officer his duty?” answered the captain, smiting the Prince in the face with his left hand.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Then swiftly he struck downwards and I saw the bronze sword pass through the body of the Israelite who quivered and lay still. It was all done in an instant, and on the silence that followed rang out the sound of a woman’s wail. For a moment Seti choked—with rage, I think. Then he spoke a single word—“Guards!”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("The four Nubians, who, as ordered, had kept at a distance, burst through the gathered throng. Ere they reached us I, who till now had stood amazed, sprang at the captain and gripped him by the throat. He struck at me with his bloody sword, but the blow, falling on my long cloak, only bruised me on the left thigh. Then I, who was strong in those days, grappled with him and we rolled together on the ground.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("After this there was great tumult. The Hebrew slaves burst their rope and flung themselves upon the soldiers like dogs upon a jackal, battering them with their bare fists. The soldiers defended themselves with swords; the overseers plied their hide whips; women screamed, men shouted. The captain whom I had seized began to get the better of me; at least I saw his sword flash above me and thought that all was over. Doubtless it would have been, had not Seti himself dragged the man backwards and thus given the four Nubian guards time to seize him. Next I heard the Prince cry out in a ringing voice:")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Hold! It is Seti, the son of Pharaoh, the Governor of Tanis, with whom you have to do. See,” and he threw back the hood of his cloak so that the moon shone upon his face.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Instantly there was a great quiet. Now, first one and then another as the truth sunk into them, men began to fall upon their knees, and I heard one say in an awed voice:")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“The royal Son, the Prince of Egypt struck in the face by a soldier! Blood must pay for it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“How is that officer named?” asked Seti, pointing to the man who had killed the Israelite and well-nigh killed me.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Someone answered that he was named Khuaka.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Bring him to the steps of the temple of Amon,” said Seti to the Nubians who held him fast. “Follow me, friend Ana, if you have the strength. Nay, lean upon my shoulder.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("So resting upon the shoulder of the Prince, for I was bruised and breathless, I walked with him a hundred paces or more to the steps of the great temple where we climbed to the platform at the head of the stairs. After us came the prisoner, and after him all the multitude, a very great number who stood upon the steps and on the flat ground beyond. The Prince, who was very white and quiet, sat himself down upon the low granite base of a tall obelisk which stood in front of the temple pylon, and said:")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“As Governor of Tanis, the City of Rameses, with power of life and death at all hours and in all places, I declare my Court open.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“The Royal Court is open!” cried the multitude in the accustomed form.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“This is the case,” said the Prince. “Yonder man who is named Khuaka, by his dress a captain of Pharaoh’s army, is charged with the murder of a certain Hebrew, and with the attempted murder of Ana the scribe. Let witnesses be called. Bring the body of the dead man and lay it here before me. Bring the woman who strove to protect him, that she may speak.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("The body was brought and laid upon the platform, its wide eyes staring up at the moon. Then soldiers who had gathered thrust forward the weeping girl.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Cease from tears,” said Seti, “and swear by Kephera the creator, and by Maat the goddess of truth and law, to speak nothing but the truth.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("The girl looked up and said in a rich low voice that in some way reminded me of honey being poured from a jar, perhaps because it was thick with strangled sobs:")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“O Royal Son of Egypt, I cannot swear by those gods who am a daughter of Israel.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("The Prince looked at her attentively and asked:")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“By what god then can you swear, O Daughter of Israel?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“By Jahveh, O Prince, whom we hold to be the one and only God, the Maker of the world and all that is therein.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Then perhaps his other name is Kephera,” said the Prince with a little smile. “But have it as you will. Swear, then, by your god Jahveh.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Then she lifted both her hands above her head and said:")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“I, Merapi, daughter of Nathan of the tribe of Levi of the people of Israel, swear that I will speak the truth and all the truth in the name of Jahveh, the God of Israel.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Tell us what you know of the matter of the death of this man, O Merapi.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Nothing that you do not know yourself, O Prince. He who lies there,” and she swept her hand towards the corpse, turning her eyes away, “was my father, an elder of Israel. The captain Khuaka came when the corn was young to the Land of Goshen to choose those who should work for Pharaoh. He wished to take me into his house. My father refused because from my childhood I had been affianced to a man of Israel; also because it is not lawful under the law for our people to intermarry with your people. Then the captain Khuaka seized my father, although he was of high rank and beyond the age to work for Pharaoh, and he was taken away, as I think, because he would not suffer me to wed Khuaka. A while later I dreamed that my father was sick. Thrice I dreamed it and ran away to Tanis to visit him. But this morning I found him and, O Prince, you know the rest.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Is there no more?” asked Seti.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("The girl hesitated, then answered:")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Only this, O Prince. This man saw me with my father giving him food, for he was weak and overcome with the toil of digging the mud in the heat of the sun, he who being a noble of our people knew nothing of such labour from his youth. In my presence Khuaka asked my father if now he would give me to him. My father answered that sooner would he see me kissed by snakes and devoured by crocodiles. ‘I hear you,’ answered Khuaka. ‘Learn, now, slave Nathan, before to-morrow’s sun arises, you shall be kissed by swords and devoured by crocodiles or jackals.’ ‘So be it,’ said my father, ‘but learn, O Khuaka, that if so, it is revealed to me who am a priest and a prophet of Jahveh, that before to-morrow’s sun you also shall be kissed by swords and of the rest we will talk at the foot of Jahveh’s throne.’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Afterwards, as you know, Prince, the overseer flogged my father as I heard Khuaka order him to do if he lagged through weariness, and then Khuaka killed him because my father in his madness struck the overseer with a mattock. I have no more to say, save that I pray that I may be sent back to my own people there to mourn my father according to our custom.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“To whom would you be sent? Your mother?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Nay, O Prince, my mother, a lady of Syria, is dead. I will go to my uncle, Jabez the Levite.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Stand aside,” said Seti. “The matter shall be seen to later. Appear, O Ana the Scribe. Swear the oath and tell us what you have seen of this man’s death, since two witnesses are needful.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("So I swore and repeated all this story that I have written down.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Now, Khuaka,” said the Prince when I had finished, “have you aught to say?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Only this, O Royal One,” answered the captain throwing himself upon his knees, “that I struck you by accident, not knowing that the person of your Highness was hidden in that long cloak. For this deed it is true that I am worthy of death, but I pray you to pardon me because I knew not what I did. The rest is nothing, since I only slew a mutinous slave of the Israelites, as such are slain every day.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Tell me, O Khuaka, who are being tried for this man’s death and not for the striking of one of royal blood by chance, under which law it is lawful for you to kill an Israelite without trial before the appointed officers of Pharaoh.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“I am not learned. I do not know the law, O Prince. All that this woman said is false.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“At least it is not false that yonder man lies dead and that you slew him, as you yourself admit. Learn now, and let all Egypt learn, that even an Israelite may not be murdered for no offence save that of weariness and of paying back unearned blow with blow. Your blood shall answer for his blood. Soldiers! Strike off his head.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("The Nubians leapt upon him, and when I looked again Khuaka’s headless corpse lay by the corpse of the Hebrew Nathan and their blood was mingled upon the steps of the temple.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“The business of the Court is finished,” said the Prince. “Officers, see that this woman is escorted to her own people, and with her the body of her father for burial. See, too, upon your lives that no insult or harm is done to her. Scribe Ana, accompany me hence to my house where I would speak with you. Let guards precede and follow me.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("He rose and all the people bowed. As he turned to go the lady Merapi stepped forward, and falling upon her knees, said:")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“O most just Prince, now and ever I am your servant.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Then we set out, and as we left the market-place on our way to the palace of the Prince, I heard a tumult of voices behind us, some in praise and some in blame of what had been done. We walked on in silence broken only by the measured tramp of the guards. Presently the moon passed behind a cloud and the world was dark. Then from the edge of the cloud sprang out a ray of light that lay straight and narrow above us on the heavens. Seti studied it a while and said:")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Tell me, O Ana, of what does that moonbeam put you in mind?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Of a sword, O Prince,” I answered, “stretched out over Egypt and held in the black hand of some mighty god or spirit. See, there is the blade from which fall little clouds like drops of blood, there is the hilt of gold, and look! there beneath is the face of the god. Fire streams from his eyebrows and his brow is black and awful. I am afraid, though what I fear I know not.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“You have a poet’s mind, Ana. Still, what you see I see and of this I am sure, that some sword of vengeance is indeed stretched out over Egypt because of its evil doings, whereof this light may be the symbol. Behold! it seems to fall upon the temples of the gods and the palace of Pharaoh, and to cleave them. Now it is gone and the night is as nights were from the beginning of the world. Come to my chamber and let us eat. I am weary, I need food and wine, as you must after struggling with that lustful murderer whom I have sent to his own place.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("The guards saluted and were dismissed. We mounted to the Prince’s private chambers, in one of which his servants clad me in fine linen robes after a skilled physician of the household had doctored the bruises upon my thigh over which he tied a bandage spread with balm. Then I was led to a small dining-hall, where I found the Prince waiting for me as though I were some honoured guest and not a poor scribe who had wandered hence from Memphis with my wares. He caused me to sit down at his right hand and even drew up the chair for me himself, whereat I felt abashed. To this day I remember that leather-seated chair. The arms of it ended in ivory sphinxes and on its back of black wood in an oval was inlaid the name of the great Rameses, to whom indeed it had once belonged. Dishes were handed to us—only two of them and those quite simple, for Seti was no great eater—by a young Nubian slave of a very merry face, and with them wine more delicious than any I had ever tasted.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("We ate and drank and the Prince talked to me of my business as a scribe and of the making of tales, which seemed to interest him very much. Indeed one might have thought that he was a pupil in the schools and I the teacher, so humbly and with such care did he weigh everything that I said about my art. Of matters of state or of the dreadful scene of blood through which we had just passed he spoke no word. At the end, however, after a little pause during which he held up a cup of alabaster as thin as an eggshell, studying the light playing through it on the rich red wine within, he said to me:")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Friend Ana, we have passed a stirring hour together, the first perhaps of many, or mayhap the last. Also we were born upon the same day and therefore, unless the astrologers lie, as do other men—and women—beneath the same star. Lastly, if I may say it, I like you well, though I know not how you like me, and when you are in the room with me I feel at ease, which is strange, for I know of no other with whom it is so.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Now by a chance only this morning I found in some old records which I was studying, that the heir to the throne of Egypt a thousand years ago, had, and therefore, as nothing ever changes in Egypt, still has, a right to a private librarian for which the State, that is, the toilers of the land, must pay as in the end they pay for all. Some dynasties have gone by, it seems, since there was such a librarian, I think because most of the heirs to the throne could not, or did not, read. Also by chance I mentioned the matter to the Vizier Nehesi who grudges me every ounce of gold I spend, as though it were one taken out of his own pouch, which perhaps it is. He answered with that crooked smile of his:")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“‘Since I know well, Prince, that there is no scribe in Egypt whom you would suffer about you for a single month, I will set the cost of a librarian at the figure at which it stood in the Eleventh Dynasty upon the roll of your Highness’s household and defray it from the Royal Treasury until he is discharged.’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Therefore, Scribe Ana, I offer you this post for one month; that is all for which I can promise you will be paid whatever it may be, for I forget the sum.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“I thank you, O Prince,” I exclaimed.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Do not thank me. Indeed if you are wise you will refuse. You have met Pambasa. Well, Nehesi is Pambasa multiplied by ten, a rogue, a thief, a bully, and one who has Pharaoh’s ear. He will make your life a torment to you and clip every ring of gold that at length you wring out of his grip. Moreover the place is wearisome, and I am fanciful and often ill-humoured. Do not thank me, I say. Refuse; return to Memphis and write stories. Shun courts and their plottings. Pharaoh himself is but a face and a puppet through which other voices talk and other eyes shine, and the sceptre which he wields is pulled by strings. And if this is so with Pharaoh, what is the case with his son? Then there are the women, Ana. They will make love to you, Ana, they even do so to me, and I think you told me that you know something of women. Do not accept, go back to Memphis. I will send you some old manuscripts to copy and pay you whatever it is Nehesi allows for the librarian.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Yet I accept, O Prince. As for Nehesi I fear him not at all, since at the worst I can write a story about him at which the world will laugh, and rather than that he will pay me my salary.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“You have more wisdom than I thought, Ana. It never came into my mind to put Nehesi in a story, though it is true I tell tales about him which is much the same thing.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("He bent forward, leaning his head upon his hand, and ceasing from his bantering tone, looked me in the eyes and asked:")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Why do you accept? Let me think now. It is not because you care for wealth if that is to be won here; nor for the pomp and show of courts; nor for the company of the great who really are so small. For all these things you, Ana, have no craving if I read your heart aright, you who are an artist, nothing less and nothing more. Tell me, then, why will you, a free man who can earn your living, linger round a throne and set your neck beneath the heel of princes to be crushed into the common mould of servitors and King’s Companions and Bearers of the Footstool?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“I will tell you, Prince. First, because thrones make history, as history makes thrones, and I think that great events are on foot in Egypt in which I would have my share. Secondly, because the gods bring gifts to men only once or twice in their lives and to refuse them is to offend the gods who gave them those lives to use to ends of which we know nothing. And thirdly”—here I hesitated.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“And thirdly—out with the thirdly for, doubtless, it is the real reason.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“And thirdly, O Prince—well, the word sounds strangely upon a man’s lips—but thirdly because I love you. From the moment that my eyes fell upon your face I loved you as I never loved any other man—not even my father. I know not why. Certainly it is not because you are a prince.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("When he heard these words Seti sat brooding and so silent that, fearing lest I, a humble scribe, had been too bold, I added hastily:")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Let your Highness pardon his servant for his presumptuous words. It was his servant’s heart that spoke and not his lips.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("He lifted his hand and I stopped.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Ana, my twin in Ra,” he said, “do you know that I never had a friend?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“A prince who has no friend!”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Never, none. Now I begin to think that I have found one. The thought is strange and warms me. Do you know also that when my eyes fell upon your face I loved you also, the gods know why. It was as though I had found one who was dear to me thousands of years ago but whom I had lost and forgotten. Perhaps this is but foolishness, or perhaps here we have the shadow of something great and beautiful which dwells elsewhere, in the place we call the Kingdom of Osiris, beyond the grave, Ana.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Such thoughts have come to me at times, Prince. I mean that all we see is shadow; that we ourselves are shadows and that the realities who cast them live in a different home which is lit by some spirit sun that never sets.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("The Prince nodded his head and again was silent for a while. Then he took his beautiful alabaster cup, and pouring wine into it, he drank a little and passed the cup to me.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Drink also, Ana,” he said, “and pledge me as I pledge you, in token that by decree of the Creator who made the hearts of men, henceforward our two hearts are as the same heart through good and ill, through triumph and defeat, till death takes one of us. Henceforward, Ana, unless you show yourself unworthy, I hide no thought from you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Flushing with joy I took the cup, saying:")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“I add to your words, O Prince. We are one, not for this life alone but for all the lives to be. Death, O Prince, is, I think, but a single step in the pylon stair which leads at last to that dizzy height whence we see the face of God and hear his voice tell us what and why we are.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Then I pledged him, and drank, bowing, and he bowed back to me.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“What shall we do with the cup, Ana, the sacred cup that has held this rich heart-wine? Shall I keep it? No, it no longer belongs to me. Shall I give it to you? No, it can never be yours alone. See, we will break the priceless thing.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Seizing it by its stem with all his strength he struck the cup upon the table. Then what seemed to me to be a marvel happened, for instead of shattering as I thought it surely would, it split in two from rim to foot. Whether this was by chance, or whether the artist who fashioned it in some bygone generation had worked the two halves separately and cunningly cemented them together, to this hour I do not know. At least so it befell.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“This is fortunate, Ana,” said the Prince, laughing a little in his light way. “Now take you the half that lies nearest to you and I will take mine. If you die first I will lay my half upon your breast, and if I die first you shall do the same by me, or if the priests forbid it because I am royal and may not be profaned, cast the thing into my tomb. What should we have done had the alabaster shattered into fragments, Ana, and what omen should we have read in them?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Why ask, O Prince, seeing that it has befallen otherwise?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Then I took my half, laid it against my forehead and hid it in the bosom of my robe, and as I did, so did Seti.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("So in this strange fashion the royal Seti and I sealed the holy compact of our brotherhood, as I think not for the first time or the last.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e22ba8a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Untitled320.vue
// module id = 75
// module chunks = 0